import { breakpoints } from "@authentic/loyalty-pwa/util/variables";
import styled from "styled-components";

export const ProcessStepStyled = styled.div`
  text-align: center;
  color: #000000;
  font-style: normal;
  background-color: white;
  width: 25%;
  height: 277px;
  padding: 72px 24px 24px;
  position: relative;
  margin-top: 72px;
  margin-left: 8px;
  margin-right: 8px;
  .title {
    font-weight: bold;
    font-size: 12px;
    line-height: 22px;
    display: block;
    text-transform: uppercase;
  }
  .subtitle {
    font-weight: bold;
    font-size: 18px;
    line-height: 22px;
  }

  p {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.01em;
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    display: flex;
    align-items: center;
    text-align: left;
    padding: 32px 24px;
    height: auto;
    margin-top: 8px;
    .process-step-info {
      flex: 1;
      padding-right: 16px;
    }

    .title {
      display: inline-block;
      margin-right: 8px;
    }
  }
`;

export const ImageContent = styled.div<{ bgColor: string, imgWidth: string, imgHeight: string, imgWidthSm: string, imgHeightSm: string }>`
  width: 100px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px;
  span {
    color: white;
    display: block;
    text-transform: uppercase;
    font-size: 12px;
    margin-top: 4px;
  }
  svg {
    width: ${(props) => props.imgWidth};
    height: ${(props) => props.imgHeight};
  }

  @media screen and (max-width: ${breakpoints.sm}) {
    left: auto;
    top: auto;
    position: relative;
    margin-left: 0;
    width: 72px;
    height: 72px;

    svg {
      width: ${(props) => props.imgWidthSm};
      height: ${(props) => props.imgHeightSm};
    }

    span {
      font-size: 10px;
    }
  }
`;